import api, { Notifiable } from './api';

export interface ItemMensagem {
    id: string;
    mensagem: string;
    nomeDoUsuario: string;
    dataHoraInclusao: string;
}

export interface ConsolidadoPluriAnual extends Notifiable {
    consolidadoPluriAnualId: string;
    mensagem: string;
}


export const getAllMensagemByConsolidadoPluriAnualId = (consolidadoPluriAnualId: string) => {
    return api.get<ItemMensagem[]>(`consolidadoPlurianualComentario/${consolidadoPluriAnualId}`);
}


export const salvarConsolidadoPlurianualComentario = (values: ConsolidadoPluriAnual) => {
    return api.post<ConsolidadoPluriAnual>(`consolidadoPlurianualComentario`, values);
}


export const getTotalComentarios = (consolidadoPluriAnualId: string) => {
    return api.get<number>(`consolidadoPlurianualComentario/totalComentarios/${consolidadoPluriAnualId}`);
}